import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OhayoThemeModule } from '@ohayojp/theme';

import { DownFileDirective } from './down-file.directive';

const DIRECTIVES = [DownFileDirective];

@NgModule({
  imports: [CommonModule, OhayoThemeModule],
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES],
})
export class DownFileModule { }
